/**
 * TBHC-specific constants for narrowly scoped, client-specific behavior.
 * Mirrors apps/api/src/utils/facility/tbhc-defaults.ts, which apps/api
 * cannot import this library to reuse directly.
 */
export const TBHC_CLINIC_SLUG = 'tbhc'
export const OFFICE_PLACE_OF_SERVICE_TYPE = 'office'
export const ON_CAMPUS_OUTPATIENT_HOSPITAL_PLACE_OF_SERVICE_TYPE = 'on_campus_outpatient_hospital'
